import { useCallback } from "react";
import { useContext } from "react";
import { updateAndSyncContract } from "../../../repositories/integrations/plug";
import { getContract } from "../../../repositories/v1/contract";
import { notify } from "../../../utils/notify";
import { ContractsContext } from "../context/ContractsContext";
import { GlobalVariables } from "../../../global";

export default function useContractsPreviewController() {
  const {
    setLoading,
    setMainLoading,
    allRows,
    setAllRows,
    setCountAllRows,
    page,
    searchFilter,
    status,
  } = useContext(ContractsContext);

  const handleGetContracts = useCallback(async () => {
    try {
      setLoading(true);

      const {
        data: { data: response },
      } = await getContract({
        pageNumber: page,
        filterByText: searchFilter,
        status,
      });

      setAllRows(response.rows);
      setCountAllRows(response.count);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [page, searchFilter, setAllRows, setCountAllRows, setLoading, status]);

  const syncContractByAdmContractId = async (
    contractIds,
    setterSelectedContracts
  ) => {
    try {
      setMainLoading(true);
      const plural = contractIds.length > 1 ? "s" : "";

      const { data: response } = await updateAndSyncContract({
        body: { contractIds },
      });

      if (!response.success) {
        throw new Error(`Não foi possível sincronizar contrato${plural}.`);
      }

      changeSyncedStatus(contractIds);
      notify(
        `Contrato${plural} sincronizado${plural} com sucesso!`,
        true,
        "success"
      );
      setterSelectedContracts([]);
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const changeSyncedStatus = (contractIds) => {
    const copyContracts = allRows;

    contractIds.forEach((contractId) => {
      const syncedContractIndex = copyContracts.findIndex(
        (contract) => contract.Id === contractId
      );
      copyContracts[syncedContractIndex].synced = true;
    });

    setAllRows([...copyContracts]);
  };

  const defineStatusDataByAcronym = (acronym) =>
    GlobalVariables.CONTRACT_STATUS.find(
      (status) => status.acronym === acronym
    );

  return {
    handleGetContracts,
    syncContractByAdmContractId,
    defineStatusDataByAcronym,
  };
}
